import store from "@/store";
import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";

export const goToMyReport = async (id) => {
  if (store.getters["common/device"] == "BROWSER") {
    router.push({
      name: "DbsMyReport",
      params: { id: id },
    });
  } else {
    nativeHandlerService.ncDbsOpenWebview(
      `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}dbs/my-report/${id}`
    );
  }
};
